import { createAction, props } from '@ngrx/store';
import { CartItem, StoreCart } from './cart.models';

/**
 * Add a new item to the cart for a specific store
 */
export const addCartItem = createAction(
  '[Cart] Add Cart Item',
  props<{ item: CartItem }>()
);

/**
 * Remove a cart item from a store
 */
export const removeCartItem = createAction(
  '[Cart] Remove Cart Item',
  props<{ storeId: string; itemId: string }>()
);

/**
 * Update an existing cart item
 */
export const updateCartItem = createAction(
  '[Cart] Update Cart Item',
  props<{ storeId: string; itemId: string; updates: Partial<CartItem> }>()
);

/**
 * Clear all items from a specific store's cart
 */
export const clearStoreCart = createAction(
  '[Cart] Clear Store Cart',
  props<{ storeId: string }>()
);

/**
 * Clear the entire cart (all stores)
 */
export const clearCart = createAction('[Cart] Clear Cart');

/**
 * Load cart from storage (e.g., localStorage)
 */
export const loadCart = createAction('[Cart] Load Cart');

/**
 * Load cart success
 */
export const loadCartSuccess = createAction(
  '[Cart] Load Cart Success',
  props<{ stores: Record<string, StoreCart> }>()
);

/**
 * Load cart failure
 */
export const loadCartFailure = createAction(
  '[Cart] Load Cart Failure',
  props<{ error: string }>()
);

/**
 * Save cart to storage
 */
export const saveCart = createAction('[Cart] Save Cart');

